import React from "react";
import NavigationBar from "../../General/NavigationBar/NavigationBar";
import PermitsSidebar from "../PermitsSidebar/PermitsSidebar";

const PermitsLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<PermitsSidebar />}>{children}</NavigationBar>
);

export default PermitsLayout;
